import styled from "styled-components";

export const Main = styled.div`
 
`;
export const Container = styled.div`
  width: 100%;
  max-width: 1033px;
  margin: 0 auto;
`;

export const Wrapper = styled.div`
  width: 100%;
`;
export const TopSearchBar = styled.div``;
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
